// components/useTopOffset.js
import { useLayoutEffect } from "react";

export function useTopOffset(ids = ["siteHeader", "categoryBar"]) {
  useLayoutEffect(() => {
    const els = ids
      .map(id => document.getElementById(id))
      .filter(Boolean);

    const calc = () => {
      const px = els.reduce((sum, el) => sum + el.offsetHeight, 0) + 12; // small gap
      document.documentElement.style.setProperty("--page-pad", `${px}px`);
    };

    calc();
    const ro = new ResizeObserver(calc);
    els.forEach(el => ro.observe(el));
    window.addEventListener("orientationchange", calc);
    window.addEventListener("resize", calc);
    return () => {
      ro.disconnect();
      window.removeEventListener("orientationchange", calc);
      window.removeEventListener("resize", calc);
    };
  }, [ids]);
}
